var React = require('react');

function ExpandLess (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},React.createElement("path",{"d":"M16 10.4l14.3 14.3 1.4-1.4L16 7.6.3 23.3l1.4 1.4"})));
}

ExpandLess.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = ExpandLess;

ExpandLess.default = ExpandLess;
